import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5e2bed6c = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _3905877c = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _0a38a665 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _1edb79ce = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _0fef7fb9 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _678e5ec6 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _59b926ca = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _4b82aa94 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _57fd9bbf = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _3c4e83e0 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _64976e98 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _25e59748 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _4fe630e2 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _52fd4f8e = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _005133f1 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _9c6ce2c8 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _86e0c2fa = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _0f4539f9 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _d48bb97c = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _d2051abc = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _234458ba = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _7f929ad9 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _acccd666 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _50264d80 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _17a6b646 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _b1a65ec2 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _370a23a1 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _04f0f881 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _a6c3d6c2 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _07095bae = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _d4d76f40 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _7413f5ad = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _344ccdfc = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _44387cb4 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _55589314 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _cd0028a4 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _f54b646e = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _823c45d6 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _48edc809 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _1a54c8c7 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _12fb6b72 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _ac8160da = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _1c2caa68 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _76c8643e = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _628866b8 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _203fc530 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _385fee4c = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _136d2a18 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _7cceaefc = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _080b3478 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _0b9b22ff = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _03a7f547 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _7b8dbc38 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _7f52442a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _57141146 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _1e0284c2 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _2a9dd521 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _5f22249e = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _1211e387 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _728a091c = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _07bacd54 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _6db52729 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _276e1f64 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _5533c7c8 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _acf9a31e = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _711dd632 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _f7d203e6 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _334bb915 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _169c1c61 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _6524fc32 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _39362fc8 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _3d054752 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _a5eea3b4 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _de0473d8 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _4460ea38 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _5fd49dc4 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _5e2bed6c,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _3905877c,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _0a38a665,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _1edb79ce,
    name: "calendar"
  }, {
    path: "/customer",
    component: _0fef7fb9,
    name: "customer"
  }, {
    path: "/details",
    component: _678e5ec6,
    name: "details"
  }, {
    path: "/goals",
    component: _59b926ca,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _4b82aa94,
    name: "maisoku"
  }, {
    path: "/media",
    component: _57fd9bbf,
    name: "media"
  }, {
    path: "/privacy",
    component: _3c4e83e0,
    name: "privacy"
  }, {
    path: "/project",
    component: _64976e98,
    name: "project"
  }, {
    path: "/response",
    component: _25e59748,
    name: "response"
  }, {
    path: "/sale",
    component: _4fe630e2,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _52fd4f8e,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _005133f1,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _9c6ce2c8,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _86e0c2fa,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _0f4539f9,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _d48bb97c,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _d2051abc,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _234458ba,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _7f929ad9,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _acccd666,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _50264d80,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _17a6b646,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _b1a65ec2,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _370a23a1,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _04f0f881,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _a6c3d6c2,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _07095bae,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _d4d76f40,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _7413f5ad,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _344ccdfc,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _44387cb4,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _55589314,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _cd0028a4,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _f54b646e,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _823c45d6,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _48edc809,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _1a54c8c7,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _12fb6b72,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _ac8160da,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _1c2caa68,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _76c8643e,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _628866b8,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _203fc530,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _385fee4c,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _136d2a18,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _7cceaefc,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _080b3478,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _0b9b22ff,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _03a7f547,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _7b8dbc38,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _7f52442a,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _57141146,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _1e0284c2,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _2a9dd521,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _5f22249e,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _1211e387,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _728a091c,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _07bacd54,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _6db52729,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _276e1f64,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _5533c7c8,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _acf9a31e,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _711dd632,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _f7d203e6,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _334bb915,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _169c1c61,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _6524fc32,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _39362fc8,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _3d054752,
    name: "property-property",
    children: [{
      path: "contact",
      component: _a5eea3b4,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _de0473d8,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _4460ea38,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _5fd49dc4,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
